module.exports = __webpack_public_path__ + "img/A4_poster_Mord23.5eee48a4.jpg";